import { Maybe } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

import { CapitalizePipe } from './capitalize.pipe';

import { ProductCategory } from '@iss/wo-common/trade-off';

@Pipe({ name: 'productCategory', pure: false, standalone: true })
export class ProductCategoryPipe extends CapitalizePipe implements PipeTransform {
  public override transform(value: Maybe<ProductCategory>): string {
    return super.transform(value);
  }
}
